import { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query'
import { FBPageTableContainer } from 'components/FbUI/Page/styles'
import { useInfiniteScroll } from 'hooks/useInfiniteScroll'
import { ReactNode } from 'react'
import { Spinner } from 'react-bootstrap'

type Props<TPage, TItem> = {
  infiniteQuery: UseInfiniteQueryResult<InfiniteData<TPage>>
  children: (items: TItem[]) => ReactNode
  extractItems: (page: TPage) => TItem[]
  className?: string
}

export function MobileInfiniteScrollView<TPage, TItem>({
  infiniteQuery,
  children,
  extractItems,
  className = 'py-4 px-2 overflow-scroll flex flex-col gap-4',
}: Props<TPage, TItem>) {
  const { data, fetchNextPage, isFetchingNextPage, hasNextPage, isLoading } =
    infiniteQuery
  const items = data?.pages?.flatMap(extractItems)
  const { containerRef, sentinelRef } = useInfiniteScroll({
    onLoadMore: fetchNextPage,
    isLoading: isFetchingNextPage,
    hasMore: hasNextPage,
  })
  return (
    <FBPageTableContainer ref={containerRef} className={className}>
      {children(items || [])}
      {/* Sentinel element for IntersectionObserver - triggers load when visible */}
      <div ref={sentinelRef} style={{ height: '1px' }} />
      <div className="flex items-center justify-center w-full h-full py-4">
        {(isFetchingNextPage || isLoading) && <Spinner animation="border" />}
      </div>
    </FBPageTableContainer>
  )
}
